<template>
  <div>
    <Header :hasLeft="false" pageTitle="学者服务" />
    <ul id="scholarService">
      <li @click="serve(1)">
        <img
          src="@/assets/img/mobile-img/scholar-service/progress.png"
          alt=""
        />
        <p>稿件进度查询</p>
      </li>
      <li @click="serve(2)">
        <img src="@/assets/img/mobile-img/scholar-service/apply.png" alt="" />
        <p>学术会议</p>
      </li>
      <li @click="serve(4)">
        <img src="@/assets/img/mobile-img/scholar-service/mall.png" alt="" />
        <p>图书商城</p>
      </li>
      <li @click="serve(5)">
        <img src="@/assets/img/mobile-img/scholar-service/scholar.png" alt="" />
        <p>百家在线-学者库</p>
      </li>
      <li @click="serve(6)">
        <img
          src="@/assets/img/mobile-img/scholar-service/peridical.png"
          alt=""
        />
        <p>百科在线-期刊库</p>
      </li>
      <li @click="serve(3)">
        <img
          src="@/assets/img/mobile-img/scholar-service/training.png"
          alt=""
        />
        <p>教育培训</p>
      </li>
    </ul>
  </div>
</template>
<script>
var vm;

import Header from "@/views/mobileView/components/header";
export default {
  name: "scholarService",
  components: {
    Header,
  },
  mixins: [],
  props: {},
  data() {
    return {
      token: "",
    };
  },
  created() {
    vm = this;
  },
  mounted() {},
  methods: {
    // 栏目点击进入
    serve(key) {
      switch (key) {
        case 1: // 稿件进度
          if (sessionStorage.getItem("token")) {
            this.$router.push({
              path: "/articleProgress",
              query: { fromHome: false },
            });
          } else {
            this.$router.push("/logins");
          }
          break;
        case 2: // 学术会议
          this.$router.push("/academicConference");
          break;
        case 3: // 教育培训列表
          this.$router.push({ path: "/educationalTraining" });
          break;
        case 4: // 百家在线列表
          this.$router.push("/bookMall");
          break;
        case 5: // 百科在线列表
          this.$router.push("/scholarOnline");
          break;
        case 6: // 百科在线列表
          this.$router.push("/periodicalOnline");
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#scholarService {
  /* margin-top: 44px; */
  padding: 44px 12px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #333;

  li {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding: 18px 15px;
    width: 100%;
    border-radius: 8px;
    background: #fff;

    img {
      width: 30px;
      height: 30px;
    }
    p {
      margin-left: 12px;
      font-weight: 700;
      font-size: 16px;
      color: #333333;
    }
  }
}
</style>
